// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"menuItem_menuItem__Q30zq","is-active":"menuItem_is-active__1o4GM"};